import React from 'react';
import FormService from '../../components/forms/formService';

const NewServicePage = (props) => {
    return (
        <FormService/>
    );
}
 
export default NewServicePage;